import { SchedulerTaskCard } from './scheduler-task-card';

export default {
  tag: 'schedulertaskcard',
  format: '<SchedulerTaskCard />',
  sourcePipeline: (source: string) => source,
  componentFn: ({ node, ...props }: any) => {
    return <SchedulerTaskCard {...props} />;
  },
};
